/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CloseContactRequest
 */
export interface CloseContactRequest {
    /**
     * 
     * @type {number}
     * @memberof CloseContactRequest
     */
    statusId?: number;
    /**
     * 
     * @type {string}
     * @memberof CloseContactRequest
     */
    notes?: string;
}

/**
 * Check if a given object implements the CloseContactRequest interface.
 */
export function instanceOfCloseContactRequest(value: object): boolean {
    return true;
}

export function CloseContactRequestFromJSON(json: any): CloseContactRequest {
    return CloseContactRequestFromJSONTyped(json, false);
}

export function CloseContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloseContactRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'statusId': json['statusId'] == null ? undefined : json['statusId'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CloseContactRequestToJSON(value?: CloseContactRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'statusId': value['statusId'],
        'notes': value['notes'],
    };
}

